// extracted by mini-css-extract-plugin
export default {"spinner":"orders__spinner__SwGYGY","spin":"orders__spin__SS8peq","large":"orders__large__yqrZ24","staticPos":"orders__staticPos__l1q8Dk"};